var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":{
		lat: -34.905118132054966,
		lng: 138.5447963269795,
	},"zoom":16,"map-type-id":"roadmap","options":{
		zoomControl: true,
		mapTypeControl: false,
		scaleControl: false,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: false,
		disableDefaultUi: false,
		styles: [{ stylers: [{ saturation: -100 }] }],
	}}},_vm._l((_vm.marker),function(mark,index){return _c('gmap-custom-marker',{key:index,attrs:{"marker":mark}},[_c('img',{attrs:{"src":_vm.marker_icon,"height":"50"}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib?{}!./scripts/vue/GoogleMap.vue?vue&type=template&id=2ae4a731&scoped=true&
// module id = 234
// module chunks = 0